import React from 'react'
import {Col, Row} from 'react-bootstrap'
import './styles.css';

const Title = ({children, mainTitle = null, actionButton = null}) => {

  let renderedTitle = (
    <div>
      <h3 className="text-uppercase">{children}</h3>
    </div>
  );
  if (mainTitle && actionButton) {
    renderedTitle = (
      <Row className="title-with-action">
        <Col md={7} lg={8}>
          <h3 className="text-uppercase">{mainTitle}</h3>
        </Col>
        <Col md={5} lg={4}>
          {actionButton}
        </Col>
      </Row>
    );
  }

  return renderedTitle;
};

export default Title;


// WEBPACK FOOTER //
// ./src/components/common/title/index.jsx